import { render } from "./Receipt.vue?vue&type=template&id=024a6357"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import "./Receipt.vue?vue&type=style&index=0&id=024a6357&scope=true&lang=css"

import exportComponent from "/Users/nakarinjaiseengam/Works/Electroic-demo/STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__